// src/pages/Skills.js
import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Skill data stays same as earlier (category, items with icons)
const skills = [
  {
    category: "Languages",
    items: [
      { name: "Core Java", icon: "fab fa-java" },
      { name: "Advance Java", icon: "fas fa-code" },
      { name: "Python (Basic)", icon: "fab fa-python" },
      { name: "SQL", icon: "fas fa-database" },
      { name: "HTML/CSS", icon: "fab fa-html5" },
      { name: "JavaScript", icon: "fab fa-js-square" },
      { name: "React.js", icon: "fab fa-react" },
    ],
  },
  {
    category: "Frameworks",
    items: [
      { name: "Spring MVC", icon: "fas fa-leaf" },
      { name: "Spring Boot", icon: "fas fa-leaf" },
      { name: "Spring Data", icon: "fas fa-leaf" },
      { name: "Spring Security", icon: "fas fa-shield-alt" },
      { name: "Spring Batch", icon: "fas fa-stream" },
      { name: "Hibernate", icon: "fas fa-database" },
      { name: "JPA", icon: "fas fa-database" },
      { name: "Apache Sling", icon: "fas fa-project-diagram" },
      { name: "React.js", icon: "fab fa-react" },
    ],
  },
  {
    category: "Databases",
    items: [
      { name: "MySQL", icon: "fas fa-database" },
      { name: "PostgreSQL", icon: "fas fa-database" },
      { name: "Elasticsearch", icon: "fas fa-search" },
      { name: "Apache Jackrabbit Oak", icon: "fas fa-folder-open" },
    ],
  },
  {
    category: "Web Technologies",
    items: [
      { name: "Cognito", icon: "fas fa-lock" },
      { name: "RESTful APIs", icon: "fas fa-plug" },
      { name: "Maven", icon: "fas fa-cogs" },
      { name: "Amazon S3", icon: "fab fa-aws" },
      { name: "Amazon SQS", icon: "fab fa-aws" },
      { name: "Data Structure", icon: "fas fa-sitemap" },
      { name: "Algorithm", icon: "fas fa-project-diagram" },
      { name: "AWS (Basic)", icon: "fab fa-aws" },
      { name: "JCR API", icon: "fas fa-code" },
      { name: "HTTP Servlets", icon: "fas fa-network-wired" },
      { name: "Docker", icon: "fab fa-docker" },
    ],
  },
  {
    category: "Developer Tools",
    items: [
      { name: "STS", icon: "fas fa-laptop-code" },
      { name: "IntelliJ IDEA", icon: "fas fa-code" },
      { name: "VS Code", icon: "fas fa-code" },
      { name: "Git", icon: "fab fa-git" },
      { name: "GitHub", icon: "fab fa-github" },
      { name: "Jira", icon: "fas fa-tasks" },
      { name: "DBeaver", icon: "fas fa-database" },
    ],
  },
  {
    category: "Others",
    items: [{ name: "Adobe Experience Manager (AEM)", icon: "fas fa-desktop" }],
  },
];

const Skills = () => {
  return (
    <Container className="mt-4">
      <h2 className="text-white text-center mb-4">🛠️ My Tech Skills</h2>
      <Row>
        {skills.map((section, idx) => (
          <Col md={6} lg={4} key={idx} className="mb-4">
            <Card
              className="text-white h-100 shadow-sm border-0"
              style={{
                background:
                  "linear-gradient(to bottom right, #1f1f1f, #292929)",
                borderRadius: "1rem",
                transition: "transform 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.02)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <Card.Body>
                <Card.Title className="text-info text-center fs-4 mb-3 border-bottom pb-2">
                  {section.category}
                </Card.Title>
                <div className="d-flex flex-wrap justify-content-center gap-3">
                  {section.items.map((skill, i) => (
                    <div
                      key={i}
                      className="text-center p-2"
                      style={{
                        width: "110px",
                        borderRadius: "0.75rem",
                        backgroundColor: "#343a40",
                        boxShadow: "inset 0 0 10px #111",
                      }}
                    >
                      <i className={`${skill.icon} fs-3 text-info`}></i>
                      <div
                        className="mt-2"
                        style={{ fontSize: "0.85rem", color: "#ddd" }}
                      >
                        {skill.name}
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Skills;
